import { IResponseActivity } from '@/core/domain/entities/activities';
import { IResponseBalance } from '@/core/domain/entities/user';
import * as ViewModel from '@/core/presenter/viewModel';
import { getStores } from '@/stores';
import { truncateString } from '@/utils';
import dayjs from 'dayjs';

/**
 * 트랜잭션 맵핑
 * @param entities
 * @returns
 */
export function toTransactions(entities: IResponseActivity[]): ViewModel.IResponseActivity[] {
  return entities.map((entity) => toTransaction(entity));
}

export function toTransaction(entities: IResponseActivity): ViewModel.IResponseActivity {
  const { presentationStore } = getStores();
  const timeStamp = entities.timeStamp;
  const ret: ViewModel.IResponseActivity = {
    txID: entities.txId,
    date: dayjs(timeStamp).format('YY.MM.DD HH:mm:ss'),
    from: entities.from,
    to: entities.to,
    from_short: truncateString(entities.from),
    to_short: truncateString(entities.to),
    amount: `${entities.type === '출금' ? '-' : '+'} ${entities.amount} ${entities.coinType}`,
    krwAmount:
      entities.coinType === ViewModel.AssetType.TRX
        ? `${(Number(entities.amount) * Number((presentationStore.balance?.trxPrice ?? 0).toFixed(6))).toLocaleString()} 원`
        : `${(Number(entities.amount) * Number((presentationStore.balance?.tokenPrice ?? 0).toFixed(6))).toLocaleString()} 원`,
    coinType: entities.coinType,
    type: toTransactionTypeText(entities.type),
    imgType: toTransactionImgFileText(entities.type),
    status: toTransactionStatus(entities.status),
    fee: entities.fee.toString(),
    from_memo: entities.from_memo,
    to_memo: entities.to_memo,
  };

  return ret;
}

export function toBalance(entities: IResponseBalance): ViewModel.IResponseBalance {
  return {
    address: entities.address,
    trxBalance: entities.trxBalance,
    trxKRW: entities.trxKRW,
    tokenBalance: entities.tokenBalance,
    tokenKRW: entities.tokenKRW,
    trxPrice: entities.trxPrice,
    tokenPrice: entities.tokenPrice,
    dbsBuyCount: entities.dbsBuyCount,
    dbsBuyCountKRW: entities.dbsBuyCountKRW,
  };
}

/**
 * 트랜잭션 상태 맵핑
 * @param status
 * @returns
 */
function toTransactionStatus(status: string): ViewModel.TransactionStatus | undefined {
  if (status === 'success') return ViewModel.TransactionStatus.SUCCESS;
  if (status === 'error') return ViewModel.TransactionStatus.FAIL;

  return undefined;
}

function toTransactionImgFileText(type: string): string {
  if (type === '출금') return 'send';
  if (type === '입금') return 'rcv';
  return type;
}

function toTransactionTypeText(type: string): string {
  if (type === '출금') return '보내기';
  if (type === '입금') return '받기';
  return type;
}
